/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Prepare_Label_JobInputs */

const en_interview_prepare_label_job = /** @type {(inputs: Interview_Prepare_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job`)
};

const de_interview_prepare_label_job = /** @type {(inputs: Interview_Prepare_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stelle`)
};

const fr_interview_prepare_label_job = /** @type {(inputs: Interview_Prepare_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emploi`)
};

const es_interview_prepare_label_job = /** @type {(inputs: Interview_Prepare_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empleo`)
};

const it_interview_prepare_label_job = /** @type {(inputs: Interview_Prepare_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavoro`)
};

const nl_interview_prepare_label_job = /** @type {(inputs: Interview_Prepare_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baan`)
};

const pl_interview_prepare_label_job = /** @type {(inputs: Interview_Prepare_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Praca`)
};

const fi_interview_prepare_label_job = /** @type {(inputs: Interview_Prepare_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Työpaikka`)
};

const da_interview_prepare_label_job = /** @type {(inputs: Interview_Prepare_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job`)
};

const sv_interview_prepare_label_job = /** @type {(inputs: Interview_Prepare_Label_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobb`)
};

/**
* | output |
* | --- |
* | "Job" |
*
* @param {Interview_Prepare_Label_JobInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_prepare_label_job = /** @type {((inputs?: Interview_Prepare_Label_JobInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Prepare_Label_JobInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_prepare_label_job(inputs)
	if (locale === "fr") return fr_interview_prepare_label_job(inputs)
	if (locale === "es") return es_interview_prepare_label_job(inputs)
	if (locale === "it") return it_interview_prepare_label_job(inputs)
	if (locale === "nl") return nl_interview_prepare_label_job(inputs)
	if (locale === "pl") return pl_interview_prepare_label_job(inputs)
	if (locale === "fi") return fi_interview_prepare_label_job(inputs)
	if (locale === "da") return da_interview_prepare_label_job(inputs)
	if (locale === "sv") return sv_interview_prepare_label_job(inputs)
	return en_interview_prepare_label_job(inputs)
});